import React from 'react'
import { Transformation } from 'cloudinary-react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

interface Link {
  url: string
  title?: string
}

interface Image {
  src: string
  title?: string
  alt?: string
}

interface CarouselItem {
  image?: Image
  overline?: string
  headline?: string
  link?: Link
}

interface MHeroSliderProps {
  data: Array<CarouselItem>
}

const MHeroSlider = ({ data }: MHeroSliderProps) => {
  const t = useTranslations()

  return (
    <Section baseClass="m-ImageCarousel m-ImageCarousel--hero" data={data}>
      <div className="m-ImageCarousel-wrapper">
        <div className="m-ImageCarousel-container">
          <div className="m-ImageCarousel-carousel">
            <div className="m-ImageCarousel-wrapper">
              <div className="m-ImageCarousel-container">
                <div className="m-ImageCarousel-carousel">
                  <div
                    className="dfb-Slider m-ImageCarousel-slider"
                    data-transition="slide"
                    data-indicators
                    data-loop="false"
                    data-drag
                    role="region"
                  >
                    <div className="dfb-Slider-slider">
                      <ul className="dfb-Slider-slides">
                        {data.length &&
                          data.map((item, index) => (
                            <li key={index} className="dfb-Slider-slideItem">
                              <figure className="m-ImageCarousel-figure">
                                <DfbImage image={item.image} aspect_ratio="16:9">
                                  <Transformation
                                    crop="fill"
                                    gravity="faces:center"
                                    width="1246"
                                    height="700"
                                    quality="auto"
                                    fetchFormat="auto"
                                  />
                                </DfbImage>
                              </figure>
                              <div className="m-ImageCarousel-text">
                                <div className="m-ImageCarousel-text-wrapper">
                                  <div className="m-ImageCarousel-text-container">
                                    <div className="m-ImageCarousel-text-content">
                                      {item.overline && (
                                        <DfbParagraph tagName="p" text={item.overline} add_class="m-ImageCarousel-overline" />
                                      )}
                                      {item.headline && (
                                        <DfbHeadline headline={item.headline} headline_level="h2" add_class="m-ImageCarousel-headline" />
                                      )}
                                      {item.link?.url && (
                                        <DfbButton
                                          tagName="a"
                                          link={item.link.url}
                                          text={item.link?.title || t('dfb_anchor.morelink')}
                                          add_class="m-ImageCarousel-button u-Theme-dark"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                  <div className="m-ImageCarousel-navigation">
                    {data.length > 1 && data.map((_, index) => <div key={index} className="m-ImageCarousel-navigation-dot"></div>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MHeroSlider
